document.addEventListener('DOMContentLoaded', function () {
    // querySelectorAll, not querySelector: there is more than one trigger
    // (the desktop icon in the top nav, and the mobile icon in the header),
    // and the singular version would only ever wire up the first one.
    const triggers = document.querySelectorAll('[data-search-trigger]');
    const overlay = document.querySelector('[data-search-overlay]');
    const closeBtns = document.querySelectorAll('[data-search-close]');

    if (!triggers.length || !overlay) return;

    const input = overlay.querySelector('input[type="search"]');

    function openSearch() {
        overlay.classList.add('is-active');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('search-open');
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
        // slight delay so the transition finishes before focusing
        setTimeout(() => input && input.focus(), 100);
    }

    function closeSearch() {
        overlay.classList.remove('is-active');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('search-open');
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    }

    function toggleSearch() {
        overlay.classList.contains('is-active') ? closeSearch() : openSearch();
    }

    // Toggle rather than open-only, so tapping the mobile icon a second
    // time closes it — on mobile the overlay's own close button can be
    // awkward to reach.
    triggers.forEach((trigger) => trigger.addEventListener('click', toggleSearch));

    closeBtns.forEach((btn) => btn.addEventListener('click', closeSearch));

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
            closeSearch();
        }
    });

    // close when clicking outside the search form itself
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
            closeSearch();
        }
    });
});